import { pushDataSocial } from 'lib/tracking';

export default {
  methods: {
    onClickSocial(brand, social) {
      pushDataSocial(brand, social);
    },
  },
};
